import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { isVariableStatement } from "typescript";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import ProductCard from "./ProductCard";
import "./Products.css";
import Cart, { generateCartItemsFrom } from "./Cart";



// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 * 
 * @property {string} name - The name or title of the product
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */


const Products = () => {
  
  //states
const[productData,setProductData] = useState([]);
const isLoggedIn = Boolean(localStorage.getItem("token"));
const token = localStorage.getItem("token");
const {enqueueSnackbar} = useSnackbar();
const[filteredProd, setFilteredProd]=useState([]);
const[loading,setLoading]=useState(false);
const[items,setItems] = useState([]);
const[cartData,setCartData] = useState([]);
const[debounceTimeout, setDebounceTimeout]= useState(null);

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Fetch products data and store it
  /**
   * Make API call to get the products list and store it to display the products
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on all available products
   *
   * API endpoint - "GET /products"
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "name": "iPhone XR",
   *          "category": "Phones",
   *          "cost": 100,
   *          "rating": 4,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "v4sLtEcMpzabRyfx"
   *      },
   *      {
   *          "name": "Basketball",
   *          "category": "Sports",
   *          "cost": 100,
   *          "rating": 5,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "upLK9JbQ4rMhTwt4"
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 500
   * {
   *      "success": false,
   *      "message": "Something went wrong. Check the backend console for more details"
   * }
   */
  const performAPICall = async () => {
  setLoading(true);
  try{
    const response = await axios.get(`${config.endpoint}/products`);
    //these two arrays holds the data
    setFilteredProd(response.data);
    setProductData(response.data);
    console.log(response.data);
    }catch(e){
    if(e.response && e.response.status === 500){
      enqueueSnackbar(e.response.data.message, {variant:"error"});
    } else{
      enqueueSnackbar("Couldn't fetched data, try again.. ", {variant:"error"});
    }
  } finally{
    setLoading(false);
  }
  };

  //product get api request
useEffect(()=>{
  performAPICall()
},[]);


// useEffect(()=>{
// fetchCart(token)
// .then((cartData) => generateCartItemsFrom(cartData,productData))
// .then((cartItems)=> setItems(cartItems))
// },[productData])



  // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
  /**
   * Definition for search handler
   * This is the function that is called on adding new search keys
   *
   * @param {string} text
   *    Text user types in the search bar. To filter the displayed products based on this text.
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on filtered set of products
   *
   * API endpoint - "GET /products/search?value=<search-query>"
   *
   */
  const performSearch = async (text) => {
try {
  const response = await axios.get(`${config.endpoint}/products/search?value=${text}`);
  setFilteredProd(response.data);
} catch (error) {
  if(error.response) {
    if(error.response.status === 404){
      setFilteredProd([]);
    }
    if(error.response.status === 500){
      enqueueSnackbar(error.response.data.message, {variant : "error"});
      setFilteredProd(productData);
    }
  } else {
      enqueueSnackbar("Something went wrong", {variant:"error"})
  }
}

  };


  // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
  /**
   * Definition for debounce handler
   * With debounce, this is the function to be called whenever the user types text in the searchbar field
   *
   * @param {{ target: { value: string } }} event
   *    JS event object emitted from the search input field
   *
   * @param {NodeJS.Timeout} debounceTimeout
   *    Timer id set for the previous debounce call
   *
   */
  const debounceSearch = (event, debounceTimeout) => {
    const value = event.target.value; //ip
    if(debounceTimeout){
      clearTimeout(debounceTimeout);// clear out the existing timer
    }
    const timeOut = setTimeout(async() => {
      await performSearch(value);
    },500)

    setDebounceTimeout(timeOut);
  };


  /**
   * Perform the API call to fetch the user's cart and return the response
   *
   * @param {string} token - Authentication token returned on login
   *
   * @returns { Array.<{ productId: string, qty: number }> | null }
   *    The response JSON object
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 401
   * {
   *      "success": false,
   *      "message": "Protected route, Oauth2 Bearer token not found"
   * }
   */
  const fetchCart = async (token) => {
    if (!token) return;

    // TODO: CRIO_TASK_MODULE_CART - Pass Bearer token inside "Authorization" header to get data from "GET /cart" API and return the response data
    try {
      const response =  await axios.get(`${config.endpoint}/cart` ,{
        headers:{
          Authorization:`Bearer ${token}`,
        }
      });
      return response.data;
      // console.log(response.data);
      // setItems(response.data);// an array of objects containing only product_id and qty only.
    } catch (e) {
      if (e.response && e.response.status === 400) {
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar(
          "Could not fetch cart details. Check that the backend is running, reachable and returns valid JSON.",
          {
            variant: "error",
          }
        );
      }
      return null;
    }
  };

  useEffect(()=>{
    const loadcart = async () =>{
      const cart = await fetchCart(localStorage.getItem("token"));
      if(cart) setCartData(cart);
    }
    loadcart();
  },[token]) //productData

  useEffect(()=>{
    if(!cartData || !productData.length) return;

    const genData = generateCartItemsFrom(cartData, productData);
    setItems(genData);
  },[cartData, productData]);


  // TODO: CRIO_TASK_MODULE_CART - Return if a product already exists in the cart
  /**
   * Return if a product already is present in the cart
   *
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { String } productId
   *    Id of a product to be checked
   *
   * @returns { Boolean }
   *    Whether a product of given "productId" exists in the "items" array
   *
   */
  const isItemInCart = (items, productId) => {
    const isInCart = items.some((item) => item.productId === productId);
    return isInCart;
  };

  /**
   * Perform the API call to add or update items in the user's cart and update local cart data to display the latest cart
   *
   * @param {string} token
   *    Authentication token returned on login
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { Array.<Product> } products
   *    Array of objects with complete data on all available products
   * @param {string} productId
   *    ID of the product that is to be added or updated in cart
   * @param {number} qty
   *    How many of the product should be in the cart
   * @param {boolean} options
   *    If this function was triggered from the product card's "Add to Cart" button
   *
   * Example for successful response from backend:
   * HTTP 200 - Updated list of cart items
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 404 - On invalid productId
   * {
   *      "success": false,
   *      "message": "Product doesn't exist"
   * }
   */
  const addToCart = async (
    token,
    items, //cart items array
    productData, //entire products array
    productId,
    qty,
    options = { preventDuplicate: false }
  ) => {
    if(!token) {
      enqueueSnackbar("Please log in to add items to the cart", {
        variant:"warning",
      });
      return;
    }
    if(options.preventDuplicate && isItemInCart(items, productId)){
      enqueueSnackbar(
      "Item already in cart. Use the cart sidebar to update quantity or remove item", 
      {
        variant: "warning"
      }
      )
      return;
    }

    try{
      const response = await axios.post(`${config.endpoint}/cart`,
      {
        productId,qty
      },
      {
        headers :{
            'Authorization' : `Bearer ${token}`
        }
      })

      const cartItem = generateCartItemsFrom(response.data, productData);
      setItems(cartItem)
    }
    catch(e){
      if(!e.response){
            enqueueSnackbar(e.response.data.message, {variant: 'error'})
      }
      else{
        enqueueSnackbar("Couldn't fetch the products, Check if the backend is running." , {variant: 'erroe'})
      }
    }
  };

  const removeFromCart = async(productId) =>{
    const token = localStorage.getItem("token");
    try{
      const res = await axios.post(
        `${config.endpoint}/cart`,
        { productId, qty: 0 },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(res.data) {
        setCartData(res.data);
      }
    }catch(error){
      console.log(error, "*******");
    }
  }

  const handleQuantity = async(
    token,
    items,
    productData,
    productId,
    qty
    ) =>{
    if(qty < 1) {
     await removeFromCart(productId);
    }else{
      await addToCart(localStorage.getItem('token'), items, productData, productId, qty)
    }
  }


  return (
    <div>
      <Header>

      </Header>

      <TextField
        className="search-mobile"
        size="small"
        fullWidth
        // value={search}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
        onChange={(e) => debounceSearch(e, debounceTimeout)}
      />



       <Grid container>
         <Grid item className="product-grid">
           <Box className="hero">
             <p className="hero-heading">
               India’s <span className="hero-highlight">FASTEST DELIVERY</span>{" "}
               to your door step
             </p>
           </Box>
         </Grid>
         {loading ? (
          <Box >
              <CircularProgress size={25}/>
              <h4>Loading Products</h4>
          </Box>
         ) : (
          <Grid container margin="1rem" padding="1rem" spacing={2}>
            
            {/* Products Grid */}
            <Grid item xs={12} md={isLoggedIn ? 9 : 12}>
              <Grid container spacing={2}>
                {filteredProd.length ? (
                  filteredProd.map((product) => (
                    <Grid item xs={6} sm={6} md={4} lg={3} key={product._id}>
                      <ProductCard productProp={product}
                      handleAddToCart={() =>
                        addToCart(token, items, productData, product._id,1,{
                          preventDuplicate: true,
                        })
                      }/>
                    
                    </Grid>
                  ))
                ) : (
                  <Box textAlign="center" width="100%">
                    <SentimentDissatisfied color="action" />
                    <h4 style={{ color: "#636363" }}>No Products found</h4>
                  </Box>
                )}
              </Grid>
            </Grid>
        
            {/* Cart Section */}
            {isLoggedIn && (
              <Grid item xs={12} md={3}>
                <Cart items={items}
                products = {productData}
                handleQuantity={handleQuantity}
                />
              </Grid>
            )}
        
          </Grid>
        )
        }
       </Grid>
      <Footer />
    </div>
  );
};

export default Products;
